// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__8r-yK","container_video":"styles_container_video__WwPg6","video":"styles_video__dUtIW","content":"styles_content__bZ5KE","button":"styles_button__qTHIU"};